<template>
  <section id="HomeContactSection">
    <div class="main_container">
      <div class="box_container">
        <div class="button_box">
          <a
            :href="$store.getters.columnData('menu_navigation_link')"
            target="_blank"
          >
            <div class="text_box">
              <h4>立即前往門市</h4>
              <p>Navigation</p>
            </div>
            <div class="image_box">
              <img
                :src="
                  $store.getters.imageUrl(
                    $store.getters.columnData('home_navigation_button_image')
                  )
                "
              />
            </div>
          </a>
        </div>
        <div class="button_box">
          <a
            :href="`tel:${$store.getters.columnData('company_phone')}`"
            target="_blank"
          >
            <div class="text_box">
              <h4>預約諮詢專線</h4>
              <p>Contact Us</p>
            </div>
            <div class="image_box">
              <img
                :src="
                  $store.getters.imageUrl(
                    $store.getters.columnData('home_contact_button_image')
                  )
                "
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeContactSection",
};
</script>
